export enum NotificationStatus {
  InProgress = 1,
  Completed,
  Failed,
  Unavailable
}
